module.exports = __webpack_public_path__ + "static/media/gallery_12_thumb.de21cb25.jpg";